/**
 * @returns Adds a class to <html />.
 */
export const addCssClass = (className: string) => {
  document?.documentElement?.classList.add(className)
}
/**
 * @returns Removes a class from  <html />.
 */
export const removeCssClass = (className: string) => {
  document?.documentElement?.classList.remove(className)
}
